<template>
	<div class="template-wrapper">
		<h2 class="page-title">{{ $t("kehulist") }}</h2>
		<el-divider></el-divider>

		<template v-if="membership_edit === '1'">
			<el-button @click="addtogroup">{{ $t("addToGroup") }}</el-button>
		</template>
        <!--
		<template>
			<export-excel :data="tableDataExcel" :fields="tableDataExcelFields" :name="$t('kehulist') + '.xls'"
				class="el-button el-button--default">
				{{ $t("exportMemberList") }}
			</export-excel>
		</template>-->
        <template v-if="exportcsv === '1'">
			<el-button @click="exporttocsv($t('kehulist'))">{{ $t("exportMemberList") }}</el-button>
		</template>

        <template v-if="membership_read === '1'">
            <br />
            <br />
            <el-collapse>
				<el-collapse-item :title="$t('searchByConditions')" name="1">
					<el-form ref="storeform" :model="storeform">
						<el-form-item :label="$t('selectStore')">
							<template>
								<div class="" style="display: flex">
									<el-select v-model="storeform.storeid" placeholder="" @change="changeStoreid">
										<el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
										<el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
											:value="item.storeid"></el-option>
									</el-select>
								</div>
							</template>
						</el-form-item>
					</el-form>
					<div>
						<el-form ref="sendernameform" :model="phoneform">
							<el-form-item :label="$t('nickname')">
								<template>
									<div class="" style="display: flex">
										<el-input v-model="sendernameform.sendername"></el-input>
									</div>
								</template>
							</el-form-item>
						</el-form>
					</div>
					<div>
						<el-form ref="phoneform" :model="phoneform">
							<el-form-item :label="$t('phoneNumber')">
								<template>
									<div class="" style="display: flex">
										<el-input v-model="phoneform.phone"></el-input>
									</div>
								</template>
							</el-form-item>
						</el-form>
					</div>

					<el-button @click="filter()">{{ $t('search') }}</el-button>
				</el-collapse-item>
			</el-collapse>
			<br />



            <!--
            <el-form ref="storeform" :model="storeform">
                <el-form-item :label="$t('selectStore')">
                    <template>
                        <div class="" style="display: flex">
                            <el-select v-model="storeform.storeid" placeholder="" @change="changeStoreid">
                                <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                                <el-option v-for="item in storelist" :label="item.storeid + ' (' + item.name + ')'"
                                    :value="item.storeid"></el-option>
                            </el-select>
                        </div>
                    </template>
                </el-form-item>
            </el-form>-->
        </template>
		

		<!--<el-button @click="dialogVisible_duo=true">{{$t('sendall')}}</el-button>-->
		<!--     <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="item.label" :name="item.id" v-for="item in tab" :key="item.id"></el-tab-pane>
        </el-tabs> -->
        <template v-if="membership_read === '1'">
            <el-table :data="tableData" stripe
			style="width: 100%" @sort-change="sortChange" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" />
                <el-table-column prop="addtime" :label="$t('date')" sortable="custom" width="180">
                    <template slot-scope="scope">
                        <div>{{ scope.row.addtime | formatDate }} </div>
                    </template>
                </el-table-column>
                <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
                </el-table-column>
                <el-table-column prop="nickname" :label="$t('nickname')" sortable="custom" width="">
                </el-table-column>
                <el-table-column prop="whatsapp" :label="$t('phoneNumber')" sortable="custom" width="">
                </el-table-column>


                <!--
                <el-table-column
                    prop="operation"
                    label="管理"
                    align="center"
                    width="180">
                    <template slot-scope="scope">
                    <div class="operationVid">
                    <span class="operationBef" @click="huifu(scope.row)" >回覆</span>
                    
                    
    
                    </div>
                    </template>
                    </el-table-column>-->

                <el-table-column prop="operation" :label="$t('adminset')" align="center" width="180">
                    <template slot-scope="scope">
                        <div class="operationVid">
                            <el-button @click="huifu(scope.row)" v-if="membership_edit === '1'">{{ $t("reply") }}</el-button>
                           <!-- <el-button @click="huifu(scope.row)" v-if="membership_edit === '1'">{{ $t("delete") }}</el-button>-->
							<span v-if="membership_edit === '0'">{{ $t("NoPermissions") }}</span>
                        </div>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pagination flex-center">
                <span class="el-pagination__total">{{ $t("total") }} {{ totalRecord }} {{ $t("items") }}</span>
                <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
                    :page-size="pageSize" layout="prev,pager,next" :total="totalRecord"></el-pagination>
            </div>
        </template>
        <template v-if="membership_read === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>

		<!-- 回覆单个客户 -->
		<el-dialog :title="$t('reply')" :visible.sync="dialogVisible" width="556px" :before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="form">

					<!--           <el-form-item :label="$t('templateType')">
                        <el-select v-model="form.type" placeholder="">
                            <el-option :label="$t('textTemplate')" value="1"></el-option>
                            <el-option :label="$t('picturesAndText')" value="2"></el-option>
                            <el-option :label="$t('ComprehensiveTemplate')" value="3"></el-option>
                        </el-select>
                    </el-form-item>
 -->
					<span>{{ $t("reply") }}:{{ hfdata.name }}</span>
					<!-- <span>whatsapp:{{hfdata.whatsapp}}</span> -->
					<el-form-item :label="$t('replyText')">
						<el-input v-model="form.msg" type="textarea" :rows="2"></el-input>
					</el-form-item>

					<el-form-item :label="$t('replyImage')">
						<el-input v-model="form.image" :rows="2"></el-input>
					</el-form-item>


				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false"> {{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="replyto">{{ $t('Sure') }}</el-button>
			</span>
		</el-dialog>
		<!-- 回覆单个客户结束 -->


		<!-- 回覆多个客户 -->
		<el-dialog :title="$t('replyall')" :visible.sync="dialogVisible_duo" width="556px" :before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="form">

					<!--           <el-form-item :label="$t('templateType')">
		                       <el-select v-model="form.type" placeholder="">
		                           <el-option :label="$t('textTemplate')" value="1"></el-option>
		                           <el-option :label="$t('picturesAndText')" value="2"></el-option>
		                           <el-option :label="$t('ComprehensiveTemplate')" value="3"></el-option>
		                       </el-select>
		                   </el-form-item>
		-->
					<span>replyto:all</span>
					<!-- <span>whatsapp:{{hfdata.whatsapp}}</span> -->
					<el-form-item :label="$t('replytxt')">
						<el-input v-model="form.msg" type="textarea" :rows="2"></el-input>
					</el-form-item>
					<el-form-item :label="$t('templateid')">
						<el-input v-model="form.templateid" type="textarea" :rows="2"></el-input>
					</el-form-item>


				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible_duo = false"> {{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="replytoall">{{ $t('Sure') }}</el-button>
			</span>
		</el-dialog>
		<!-- 回覆多个客户结束 -->


		<!-- 修改客户资料 -->
		<el-dialog :title="$t('edit')" :visible.sync="dialogVisible_key" width="556px" :before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="formkey">


					<el-form-item :label="$t('memo')">
						<span> {{ $t("remark") }}</span>
						<el-input v-model="formkey.memo"></el-input>

					</el-form-item>

					<el-form-item :label="$t('level')">
						<span> </span>
						<el-input v-model="formkey.level"></el-input>

					</el-form-item>


				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible_key = false">{{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="surekey">{{ $t('Sure') }}</el-button>
			</span>
		</el-dialog>

		<!-- 修改客户资料结束 -->
		<el-dialog :title="$t('addToGroup')" :visible.sync="addtoGroupVisible" width="556px"
			:before-close="handleClose">
			<div class="add-template">
				<el-form ref="groupform" :model="groupform">
					<el-form-item :label="$t('addToGroup')">
						<template>
							<div class="flex flex-wrap" style="display: flex">
								<el-select v-model="groupform.title" placeholder="">
									<template v-for="(item, index) in groupData">
										<el-option :label="item.title" :value="item.id">{{ item.title }}</el-option>
									</template>
								</el-select>
							</div>
						</template>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addtoGroupVisible = false"> {{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="addToGroupAction">{{ $t('Sure') }}</el-button>
			</span>
		</el-dialog>


		<el-dialog :title="$t('transactionRecord')" :visible.sync="dialogVisible_order" width="556px"
			:before-close="handleClose">
			<div class="add-template">
				<el-form ref="form" :model="form">
					<el-table :data="tableData_order.slice((currentPage_order - 1) * pageSize_order, currentPage_order * pageSize_order)
						" stripe @sort-change="sortChange_order" style="width: 100%">

						<el-table-column prop="addtime" :label="$t('time')" sortable="custom">
							<template slot-scope="scope">
								<div>{{ scope.row.addtime | formatDate }} </div>
							</template>
						</el-table-column>
						<el-table-column prop="orderid" :label="$t('orderid')" sortable="custom">
						</el-table-column>
						<el-table-column prop="total_price" :label="$t('totalAmount')" sortable="custom">
						</el-table-column>
					</el-table>
					<div class="pagination flex-center">
						<span class="el-pagination__total">{{ $t("total") }} {{ tableData_order.length }} {{ $t("items")
							}}</span>
						<el-pagination background @current-change="handleCurrentChange_order"
							:current-page="currentPage_order" :page-size="pageSize_order" layout="prev,pager,next"
							:total="tableData_order.length"></el-pagination>
					</div>





				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible_order = false"> {{ $t('Cancel') }}</el-button>
				<el-button type="primary" @click="dialogVisible_order = false">{{ $t('Sure') }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>
<script>
import { formatDate } from '../../assets/date.js'
import { tongyong, sjk, funk, api_tongyong_edit } from '@/api'
import { addTemplate, getStore, getUsersReport, getUserList, getUserListAdmin, exportUserList, getDaifafile, getDaifalistByGroup, getShopOrder } from '@/api'
export default {
	data() {
		return {
            membership_read: '0',
            membership_edit: '0',
            exportcsv: '0',
			hfdata: [],
			sjk: 'messenger_kehulist',
			currentPage: 1,  // 当前页码
			currentPage_order: 1,  // 当前页码
			pageSize: 15,  // 每页显示的行数
			pageSize_order: 10,  // 每页显示的行数
			activeName: '0',
			dialogVisible: false,
			dialogVisible_key: false,
			dialogVisible_duo: false,
			dialogVisible_order: false,
			tab: [
				{ label: this.$t('underApproval'), id: '0' },
				{ label: this.$t('passed'), id: '1' }
			],
			tableData: [],
			tableDataExcel: [],
			tableDataExcelFields: {
				'add time': 'addtime',
				'store id': 'storeid',
				'name': 'name',
				'mobile': 'whatsapp',
				'number of order': 'orders'
			},
			storelist: [],
			sjkData: [],
			tableData1: [

			],
			tableData_order: [],
			status: 0,
			form: {
				templateid: '',
				msg: '',

			},
			storeform: {
				storeid: ''
			},
			formUser: {
				qyid: '',
				start: "1-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear(),
				end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getFullYear()
			},
			sform: {
				parmas: {}
			},
			formkey: {
				keyword: 'kkk'
			},
            sendernameform: {
				sendername: ''
			},
			phoneform: {
				phone: ''
			},
			qyid: '',
            storeid: '',
			selection: [],
			selectionlist: [],
			addtoGroupVisible: false,
			groupData: [],
			groupform: {
				title: ''
			},
		}
	},
	filters: {
		formatDate: function (time) {
			time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
			let date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		}
	},
	created(option) {
        //var user = JSON.parse(window.localStorage.getItem('userinfo'))
		//this.qyid = user.id
		//console.log('sjk', this.sjk);
        var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        //this.qyid = user.id
        this.qyid = auser.qyid
        this.storeid = auser.storeid
        if(auser.storeid) {
            this.storeform.storeid = auser.storeid
        }
        this.membership_read = auser.membership_read
        this.membership_edit = auser.membership_edit
        this.exportcsv = auser.exportcsv
		if (this.sjk) {
			this.getsjk()
			this.getUserList(auser.storeid)
			//this.gettemplist()
		}
		

		this.getGroupList();
		this.getstorelist();

	},
	methods: {
		edititem(data) {
			this.dialogVisible_key = true
			this.action = 'edit'
			this.formkey = data
		},
		huifu(data) {
			this.dialogVisible = true
			this.hfdata = data
		},
		showOrder(data) {
			console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaa')
			console.log(data.whatsapp)
			console.log(data.storeid)

			//var user = JSON.parse(window.localStorage.getItem("userinfo"));
            var auser = JSON.parse(window.localStorage.getItem("auserinfo"));

			let fdata = {
				//qyid: user.id,
                qyid: auser.qyid,
				storeid: data.storeid,
				whatsapp: data.whatsapp,
				action: "viewpaymentbywhatsapp"
			};
			getShopOrder(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.tableData_order = res.data;
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});





			this.dialogVisible_order = true
			//this.hfdata = data 
		},
		beforeHandleCommand(e) {
			console.log(e);
		},
		// 页面切换方法
		handleCurrentChange(val) {
			this.currentPage = val;
            this.getUserList(this.storeform.storeid)
		},
		handleCurrentChange_order(val) {
			this.currentPage_order = val;
		},
		handleClick(tab, event) {
			console.log(tab.index);
			this.status = tab.index
			this.currentPage = 1
			this.gettemplist()
		},
		handleClose() {
			this.dialogVisible = false
			this.dialogVisible_key = false
			this.dialogVisible_duo = false
			this.dialogVisible_order = false
			this.addtoGroupVisible = false
		},
		handlePictureCardPreview() {

		},
		handleRemove() {

		},
		handleSelectionChange(val) {
			//alert(val)
			console.log('valllllllllllllll')
			console.log(val);
			this.selection = val;
		},
		addtogroup() {
			console.log('selectionnnnnnnnnnnnnnnnnnnnnnn')
			console.log(this.selection)
			this.selectionlist = this.selection;
			this.addtoGroupVisible = true;



		},
        exporttocsv(name) {
			//var user = JSON.parse(window.localStorage.getItem('userinfo'))
            var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
			let fdata = {
				//qyid: user.id,
                qyid: auser.qyid,
				storeid: this.storeform.storeid,
                sendername: this.sendernameform.sendername,
				phone: this.phoneform.phone
			};
			exportUserList(fdata).then(res => {
				if (res.code == 1) {
					console.log(res)
					//this.tableData = res.data
                    //this.totalRecord = res.total;
					this.tableDataExcel = res.dataExcel
					var csvContent= [
                    Object.keys(this.tableDataExcel[0]).join(","),
                        ...this.tableDataExcel.map(item => Object.values(item).join(","))
                    ]
                        .join("\n")
                        .replace(/(^\[)|(\]$)/gm, "");
                    var link = document.createElement('a');
                    // "\ufeff"是为了解决CSV中文乱码问题
                    var blob = new Blob(["\ufeff" +csvContent],{type: 'text/csv;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    link.href = url;
                    link.setAttribute('download', name + '.csv');
                    link.click();
                    document.body.removeChild(link);
                        } else {
                            console.log('eeeeeeeeeeeeeeeeeeeeee')
                            this.$message({
                                type: 'error',
                                message: res.msg
                            })
                        }
                    })







            


		},
        filter() {
			//this.gettemplist(this.storeform.storeid)
            this.getUserList(this.storeform.storeid)

		},
		getstorelist() {
			//console.log('go taocan');
			//var user = JSON.parse(window.localStorage.getItem('userinfo'))
            var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
            console.log('aaaaaaaaaaaaaaaaaauser')
            console.log(auser.storeid)
			let fdata = {
				qyid: auser.qyid,
                storeid: auser.storeid,
			};
			getStore(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.storelist = res.data
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
		changeStoreid() {
			console.log('storeid:' + this.storeform.storeid)
			this.getUserList(this.storeform.storeid)
		},
		// 新增範本点击确定
		sure() {
			//var user = JSON.parse(window.localStorage.getItem('userinfo'))
            var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
			console.log(user);

			//this.form.qyid = user.id
            this.form.qyid = auser.qyid
			this.form.status = 0
			addTemplate(this.form).then(res => {
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: res.msg
					})
					this.dialogVisible = false
					this.gettemplist()
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		//删除某个
		delitem(id) {
			this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

				console.log('del..');
				let fdata = {
					sjk: this.sjk,
					action: 'del',
					id: id
				}
				tongyong(fdata).then(res => {
					if (res.code == 1) {
						console.log(res);
						this.gettemplist()
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			}).catch(_ => {



			})


		},
		userReport() {
			/*
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
			let fdata = {
				qyid: user.id,
			};
			console.log('getUsersReport................')
			getUsersReportExcel(fdata).then(res => {
				if(res.code==1){
					console.log('getUsersReporttttttttttttttttttt')
					console.log(res)
					//this.tableData=res.data
					console.log('getUsersReporttttttttttttttttttttt')
				}else{
					console.log('eeeeeeeeeeeeeeeeeeeeee')
					this.$message({
						type: 'error',
						message: res.msg
					})
				}    
			})*/

		},
		getGroupList() {
			//var user = JSON.parse(window.localStorage.getItem("userinfo"));
            var auser = JSON.parse(window.localStorage.getItem("auserinfo"));
			let fdata = {
				qyid: auser.qyid,
			};
			getDaifafile(fdata).then((res) => {
				if (res.code == 1) {
					console.log(res);
					this.groupData = res.data;
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			})
		},
		addToGroupAction() {
			console.log('addToGroupActionnnnnnnnnnnnnnnnn')
			console.log('groupform.title: ' + this.groupform.title)
			console.log('this.selection: ' + this.selection)
			console.log('this.selectionlist: ')
			console.log(this.selectionlist)
			//getDaifalistByGroup

			let fdata = {
				action: 'insertlist',
				qyid: this.qyid,
				insertid: this.groupform.title,
				list: this.selectionlist,
			}

			getDaifalistByGroup(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.$message({
						type: "success",
						message: res.msg,
					});
				} else {
					console.log(res)
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
				this.handleClose();
			})

		},
		getUserList(storeid) {
			//var user = JSON.parse(window.localStorage.getItem('userinfo'))
            var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
			console.log(auser);
			let fdata = {
				qyid: auser.qyid,
				storeid: storeid,
                sendername: this.sendernameform.sendername,
				phone: this.phoneform.phone,
                record_page: this.currentPage,
                record_limit: 15,
			};
			console.log('getUsersReport................')
			getUserListAdmin(fdata).then(res => {
				if (res.code == 1) {
					console.log('getUsersReporttttttttttttttttttt')
					console.log(res)
					this.tableData = res.data
                    this.totalRecord = res.total;
					//this.tableDataExcel = res.dataExcel
					console.log('getUsersReporttttttttttttttttttttt')
				} else {
					console.log('eeeeeeeeeeeeeeeeeeeeee')
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		// 我的模板列表
		gettemplist() {

			//var user = JSON.parse(window.localStorage.getItem('userinfo'))
            var auser = JSON.parse(window.localStorage.getItem('auserinfo'))

			let fdata = {
				sjk: this.sjk,
				action: 'list',
				// status:this.status,
				// moresearch:'status,',
				//qyid: user.id
                qyid: auser.qyid
			}
			console.log('go taocan', fdata);
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.tableData = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		// 读取数据库结构
		getsjk() {
			console.log('go sjk');

			let fdata = {
				sjk: this.sjk,

			}
			sjk(fdata).then(res => {
				if (res.code == 1) {
					console.log('sjk', res);
					this.sjkData = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		replyto() {
			//var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
            var auser = JSON.parse(window.localStorage.getItem('userinfo'))
			this.qyid = auser.qyid
			let fdata = {
				do: 'sendwhatsapp',
				qyid: this.qyid,
				storeid: this.storeform.storeid,
				pageid: this.pageid,
				msg: this.form.msg,
				image: this.form.image,
				Phone: this.hfdata.whatsapp,
				templateid: this.form.templateid

			}
			console.log("fdata");
			console.log(fdata);
			this.$confirm(this.$t('sendConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				funk(fdata).then(res => {
					if (res.code > 0) {
						console.log(res);
						//this.gettemplist()
						this.$message({
							type: 'success',
							message: 'ok'
						})
						this.dialogVisible = false;
					} else {
						this.$message({
							type: 'error',
							message: 'error'
						})
					}
				})
			}).catch(_ => {



			})
		},


		replytoall() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
            var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
			this.qyid = auser.qyid
			let fdata = {
				do: 'api_sendrw_insert',
				qyid: this.qyid,
				pageid: this.pageid,
				msg1: this.form.msg,
				language: 'zh_HK',
				type: 'businessApi',
				daifaid: '9999',
				title: 'PC群发',

				templateid: this.form.templateid

			}
			this.$confirm(this.$t('sendConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {
				funk(fdata).then(res => {
					if (res.code > 0) {
						console.log(res);
						this.gettemplist()
						this.$message({
							type: 'success',
							message: 'ok'
						})
						this.dialogVisible_duo = false;
					} else {
						this.$message({
							type: 'error',
							message: 'error'
						})
					}
				})
			}).catch(_ => {



			})
		},
		// 修改key
		surekey() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);


			this.formkey.sjk = 'messenger_kehulist'
			this.formkey.updatekey = 'level,memo'
			this.formkey.setkey = 'id'



			let data = JSON.stringify(this.formkey);

			this.sform.parmas = data

			api_tongyong_edit(this.sform).then(res => {
				console.log(res);
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: res.msg
					})
					this.dialogVisible_key = false

				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		sortChange({ prop, order }) {
			this.tableData.sort(this.compare(prop, order));
		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName]
				var value2 = obj2[propertyName]
				if (typeof value1 === 'string' && typeof value2 === 'string') {
					const res = value1.localeCompare(value2, 'zh')
					return sort === 'ascending' ? res : -res
				} else {
					if (value1 <= value2) {
						return sort === 'ascending' ? -1 : 1
					} else if (value1 > value2) {
						return sort === 'ascending' ? 1 : -1
					}
				}
			}
		},
		sortChange_order({ prop, order }) {
			this.tableData_order.sort(this.compare(prop, order));
		}

	},



}
</script>
<style lang="scss" scoped>
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}

.pagination {
	width: 100%;
	margin: 30px auto;
}

::v-deep .el-select {
	width: 100%;

}
</style>